// extracted by mini-css-extract-plugin
export default {"pagination":"Paginations_pagination__GBsTv","active":"Paginations_active__dI8kg","prevNext":"Paginations_prevNext__EHUs4","disabled":"Paginations_disabled__q1SDF"};